const Selection = () => {
  return (
    <section id="cuidados" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title mb-0">Cuidados e Segurança</h5>
        </div>
        <div className="card-body">
          <div className="card">
            <div className="card-body p-3">
              <ul className="list-unstyled p-0 m-0">
                <li className="pb-0 d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="fw-bold">Tratamento de dados</div>

                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0">
                          Este sistema utiliza e processa dados pessoais, como
                          senhas, endereços de rede e registro dos dados de
                          clientes.
                        </p>
                      </li>
                      <li>
                        <p className="mt-0">
                          LGPD - Lei Geral de Proteção de Dados Pessoais: este
                          produto faz tratamento de dados pessoais, porém a
                          Intelbras não possui acesso aos dados a partir deste
                          produto. Este produto possui criptografia na
                          transmissão e armazenamento dos dados pessoais.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="pb-0 d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="fw-bold">Proteção e segurança de dados</div>
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0">
                          Observar as leis locais relativas à proteção e uso de
                          dados e as regulamentações que prevalecem no país.
                        </p>
                      </li>
                      <li>
                        <p className="mt-0">
                          O objetivo da legislação de proteção de dados é evitar
                          infrações nos direitos individuais de privacidade,
                          baseadas no mau uso dos dados pessoais.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="pb-0 d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="fw-bold">
                      Diretrizes que se aplicam aos funcionários da Intelbras
                    </div>
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0">
                          Os funcionários da Intelbras devem cumprir com as
                          práticas de comércio seguro e confidencialidade de
                          dados sob os termos dos procedimentos de trabalho da
                          companhia.
                        </p>
                      </li>

                      <li>
                        <p className="mt-0">
                          É imperativo que as regras a seguir, sejam observadas
                          para assegurar que as provisões estatutárias
                          relacionadas a serviços (sejam serviços internos ou de
                          administração e manutenção remota) sejam estritamente
                          seguidas. Isso preserva os interesses do cliente e
                          oferece proteção pessoal adicional.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="pb-0 d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="fw-bold">
                      Diretrizes que controlam o tratamento de dados
                    </div>
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0">
                          Assegurar que apenas pessoas autorizadas tenham acesso
                          aos dados de clientes.
                        </p>
                      </li>

                      <li>
                        <p className="mb-0">
                          Usar as facilidades de atribuição de senhas, sem
                          permitir qualquer exceção. Jamais informar senhas para
                          pessoas não autorizadas.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0">
                          Assegurar que nenhuma pessoa, não autorizada, tenha
                          como processar (armazenar, alterar, transmitir,
                          desabilitar ou apagar) ou usar dados de clientes.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0">
                          Evitar que pessoas, não autorizadas, tenham acesso aos
                          meios de dados, por exemplo, discos de backup ou
                          impressões de protocolos.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0">
                          Assegurar que os meios de dados que não são mais
                          necessários, sejam completamente destruídos e que
                          documentos não sejam armazenados ou deixados em locais
                          geralmente acessíveis.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0">
                          O trabalho em conjunto com o cliente gera confiança.
                        </p>
                      </li>
                      <li>
                        <p className="mt-0">
                          Este produto possui criptografia na transmissão dos
                          dados pessoais.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="pb-0 d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="fw-bold">
                      Uso indevido e invasão de hackers
                    </div>
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0">
                          As senhas de acesso às informações do produto,
                          permitem o alcance e a alteração de qualquer
                          facilidade, como o acesso externo ao sistema da
                          empresa para obtenção de dados, portanto, é de suma
                          importância que as senhas sejam disponibilizadas
                          apenas àqueles que tenham autorização para uso, sob o
                          risco de uso indevido.
                        </p>
                      </li>
                      <li>
                        <p className="mt-0">
                          O produto possui configurações de segurança que podem
                          ser habilitadas, e que serão abordadas neste manual,
                          todavia, é imprescindível que o usuário garanta a
                          segurança da rede na qual o produto está instalado,
                          haja vista que o fabricante não se responsabiliza pela
                          invasão do produto via ataques de hackers e crackers.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="d-flex flex-row align-items-center justified-text flex-xss-wrap flex-sm-nowrap flex-md-nowrap">
                      <img
                        src="./res/img/alert-icon.jpg"
                        alt=""
                        id="alert-icon"
                      />
                      <p className="mb-0 ms-md-2 ms-sm-2">
                        <strong>ATENÇÃO:</strong> <br /> Este produto vem com
                        uma senha-padrão de fábrica. Para sua segurança, é
                        IMPRESCINDÍVEL que você a troque assim que instalar o
                        produto e questione o seu técnico quanto as senhas
                        configuradas, quais os usuários que possuem acesso e os
                        métodos de recuperação.
                      </p>
                    </div>
                  </div>
                </li>
                <br />
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div className="d-flex flex-row align-items-center justified-text flex-xss-wrap flex-md-wrap">
                      <img
                        src="./res/img/anatel.png"
                        className="img-fluid"
                        alt=""
                      />
                      <p className="mb-0 ms-md-2 ms-sm-1 ms-xss-1">
                        <strong>ATENÇÃO:</strong> <br /> Este equipamento não
                        tem direito à proteção contra interferência prejudicial
                        e não pode causar interferência em sistemas devidamente
                        autorizados.
                      </p>
                      <p className="mb-0 mt-2 ms-md-2 ms-sm-1 ms-xss-1 d-block">
                        Este é um produto homologado pela Anatel, o número de
                        homologação se encontra na etiqueta do produto, para
                        consultas acesse o site:{" "}
                        <a href="https://sistemas.anatel.gov.br/sch">
                          sistemas.anatel.gov.br/sch
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Selection;
